import { useCallback } from 'react';

import {
    SettingsPanel,
    SubtitleOverlay,
    SubtitleSettingsPanelPage,
    UIContainer,
    UIManager,
} from 'bitmovin-player/bitmovinplayer-ui';
import { PlayerAPI } from 'bitmovin-player/modules/bitmovinplayer-core';

type Params = {
    subtitleFontSize: '75' | '100' | '200' | '300' | undefined;
};

function useCustomUI() {
    return useCallback((_player: PlayerAPI, config?: Params) => {
        const subtitleOverlay = new SubtitleOverlay();
        const settingsPanel = new SettingsPanel({
            components: [],
            hidden: true,
        });

        // Subtitle styling only works if a `SubtitleSettingsPanelPage` (with the corresponding Subtitle Settings elements)
        // are in the UI tree.
        const subtitleSettingsPanelPage = new SubtitleSettingsPanelPage({
            settingsPanel,
            overlay: subtitleOverlay,
        });
        settingsPanel.addComponent(subtitleSettingsPanelPage);

        // Create a custom UI structure with only the SubtitleOverlay (and the hidden SettingsPanel to enable UI customizations)
        const subtitleUI = new UIContainer({
            components: [subtitleOverlay, settingsPanel],
        });

        // Launch the UI
        const uiManager = new UIManager(_player, subtitleUI);

        // Subtitles can be customized using the SubtitleSettingsManager.
        // Supported values for `fontSize` can be found here (the `key` properties):
        // https://github.com/bitmovin/bitmovin-player-ui/blob/a8c1d1e7d5eda4154841bbc457848520a2d870bf/src/ts/components/subtitlesettings/fontsizeselectbox.ts#L23-L30
        uiManager.getSubtitleSettingsManager().fontSize.value =
            config?.subtitleFontSize || '100';
    }, []);
}

export default useCustomUI;
